import { useCallback } from "react";
import { buildBaseEvent, trackEventBestEffort } from "../track";
import { useTrackingRuntime } from "../TrackingProvider";

export const useTrackingEvent = () => {
  const runtime = useTrackingRuntime();

  const buildEvent = useCallback(
    (event) =>
      buildBaseEvent({
        ...event,
        context: event?.context,
        eventTime: event?.eventTime,
        schemaVersion: runtime.schemaVersion,
        visitorCountry: runtime.visitorCountry?.countryCode || undefined,
      }),
    [runtime.schemaVersion, runtime.visitorCountry?.countryCode]
  );

  const trackEvent = useCallback(
    async (event, options) => {
      const payload = buildEvent(event);
      await trackEventBestEffort(payload, options);
      return payload;
    },
    [buildEvent]
  );

  return { runtime, buildEvent, trackEvent };
};
